import { ORDER } from '../../namespace/order/order'
import { ORDER_ITEMS } from '../../namespace/order/order-items'
import { saveOrderState } from '../../../helpers/order-state'
import { store } from '../../index'
import {Analytics} from "@/components/analytics";

export const order = {
  state: {
    orderPopup: false,
    props: null,
    list: [
      {
        id: 'services',
        name: 'Choose a Service'
      },
      {
        id: 'closet',
        name: 'How Much Storage Do You Need?'
      },
      {
        id: 'checkout',
        name: 'Checkout'
      }
    ],
    currentStep: 'services',
    zipCode: null,
    partnerLogo: 'img/kass_logo.png',
    movingMeta: {
      isHome: false
    }
  },
  mutations: {
    [ORDER.MUTATIONS.SET_ORDER_POPUP](state, status) {
      state.orderPopup = status
    },

    [ORDER.MUTATIONS.SET_MOVING_META](state, movingMeta) {
      state.movingMeta = movingMeta
    },

    [ORDER.MUTATIONS.SET_CURRENT_STEP](state, name) {
      if (name === 'services') {
        state.zipCode = null
      }
      state.currentStep = name
      try {
        saveOrderState()
      } catch (e) {
        console.warn('Save order state error', e)
      }
    },
    [ORDER.MUTATIONS.SET_ZIP_CODE](state, zipCode) {
      state.zipCode = zipCode
    },

    [ORDER.MUTATIONS.SET_ORDER_PROPS](state, props) {
      state.props = props
    }
  },
  actions: {
    [ORDER.ACTIONS.PREVIOUS_STEP](context) {
      const currentIndex = context.state.list.findIndex(
          (step) => step.id === context.state.currentStep
      )

      const currentStepIndex = currentIndex;
      const previousStepIndex = currentIndex - 1;

      console.debug('previousStep', currentStepIndex, previousStepIndex);

      const targetStep = context.state.list[previousStepIndex]

      if (targetStep) {
        context.commit(ORDER.MUTATIONS.SET_CURRENT_STEP, targetStep.id)
      }
    },

    [ORDER.ACTIONS.NEXT_STEP](context) {
      const currentIndex = context.state.list.findIndex(
        (step) => step.id === context.state.currentStep
      )

      const currentStepIndex = currentIndex;
      const nextStepIndex = currentIndex + 1;

      console.debug('nextStep', currentStepIndex, nextStepIndex);

      if (currentStepIndex === 0 && nextStepIndex === 1) {
        try {
          Analytics.orderStep1Passed(context.rootState.orderServices.activeServiceId);
        }
        catch (e) {
          console.error(e);
        }
      }
      else if (currentStepIndex === 1 && nextStepIndex === 2) {
        try {
          Analytics.orderStep2Passed(context.rootState.orderServices.activeServiceId);
        }
        catch (e) {
          console.error(e);
        }
      }

      const targetStep = context.state.list[nextStepIndex]

      if (targetStep) {
        context.commit(ORDER.MUTATIONS.SET_CURRENT_STEP, targetStep.id)

        if (targetStep.id === 'closet') {
          context.dispatch(ORDER_ITEMS.ACTIONS.CLEAR_STORE)
        }

        if (targetStep.id === 'services') {
          context.commit(ORDER.MUTATIONS.SET_ZIP_CODE, null)
          context.commit(`orderServices/setActiveServiceId`, null)
        }
      }
    }
  },

  getters: {
    [ORDER.GETTERS.CURRENT_STEP](state) {
      return state.currentStep
    },

    [ORDER.GETTERS.LIST](state) {
      const serviceId = store.getters[`orderServices/activeServiceId`]

      if (serviceId) {
        const list = state.list
        const closetIndex = list.findIndex((item) => item.id === 'closet')
        if (serviceId === 'storage') {
          list[closetIndex].name = 'How Much Storage Do You Need?'
        }
        if (serviceId === 'moving') {
          list[closetIndex].name =
            'Convenient Supplies to Help You With Your Move'
        }
        if (serviceId === 'partners') {
          list[closetIndex].name = 'Your Vault'
        }
        return list
      } else {
        return state.list
      }
    },

    [ORDER.GETTERS.ZIP_CODE](state) {
      return state.zipCode
    },

    [ORDER.GETTERS.PARTNER_LOGO](state) {
      return state.partnerLogo
    },

    [ORDER.GETTERS.MOVING_META](state) {
      return state.movingMeta
    },

    [ORDER.GETTERS.ORDER_PROPS](state) {
      return state.props
    },

    [ORDER.GETTERS.ORDER_POPUP](state) {
      return state.orderPopup
    }
  }
}
